'use client';

import type { PropsWithChildren, ReactNode } from 'react';
import { BodyContent } from '../../../components/BodyContent/BodyContent';
import { UserLogger } from '../../../components/FullStory/UserLogger';
import Header from '../../../components/header/Header';
import { HelpModal } from '../../../components/help/HelpModal';
import { AuthenticatedWrapper } from '../../../contexts/TokenContext/AuthenticatedEmployeeWrapper';
import { MsalWrapper } from '../../../contexts/TokenContext/MsalWrapper';

export default function Layout({ children }: PropsWithChildren): ReactNode {
	return (
		<MsalWrapper>
			<UserLogger>
				<AuthenticatedWrapper>
					<Header />
					<BodyContent>{children}</BodyContent>
					<HelpModal />
				</AuthenticatedWrapper>
			</UserLogger>
		</MsalWrapper>
	);
}
